import * as React from 'react';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';

import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import { NameOf } from 'src/utils/NameOf';
import { PageProps } from 'src/models/common/ComponentProps';

import ReportHeader from 'src/components/common/ReportHeader';
import DataTable, { DataTableButtonExport, DataTableColumnProps, Filterer } from 'src/components/common/DataTable';
import ReportRequestDTO from 'src/models/datatable/ReportRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import ReportApiController from 'src/api/ReportApiController';
import ReportHeaderDTO from 'src/models/report/ReportHeaderDTO';
import StudentGameCompletionReportDTO from 'src/models/report/StudentGameCompletionReportDTO';
import './AdminReports.less';
import { Grades } from 'src/constants/Grades';
import { Icon } from 'antd';

interface StudentGameCompletionReportProps extends PageProps<{}> {
}

interface StudentGameCompletionReportState {
    isLoading: boolean;
    filterParams: Partial<ReportHeaderDTO>;
}

class StudentGameCompletionReport extends React.Component<StudentGameCompletionReportProps, StudentGameCompletionReportState> {
    private standardDataTableRef: DataTable<StudentGameCompletionReportDTO>;

    constructor(props) {
        super(props);
        bindAllOfThis(this, StudentGameCompletionReport.prototype);

        this.state = {
            isLoading: false,
            filterParams: null
        };
    }

    private fetchData(requestState: ReportRequestDTO<ReportHeaderDTO>, checkEcho: () => boolean, callback: (response: TableResponseDTO<StudentGameCompletionReportDTO>) => void): void {
        // Add custom filtering into the request
        requestState.filterData = this.state.filterParams as ReportHeaderDTO;

        // Show nothing in datatable if there are no filters, represented as {} from the reset function
        if (this.state.filterParams == null) {
            // Clear out the datatable as the clear button ends up here as well
            callback({ results: [], filteredCount: 0 } as TableResponseDTO<StudentGameCompletionReportDTO>);
            return;
        }

        this.setState({ isLoading: true });
        ReportApiController.getStudentGameCompletionReport(requestState)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                this.setState({
                    isLoading: false
                });

                callback(results.data);
            });
    }

    private handleOnReset() {
        this.setState({ filterParams: null }, () => this.standardDataTableRef.refresh());
    }

    private handleOnSubmit(filterParams: Partial<ReportHeaderDTO>) {
        this.setState({ filterParams }, () => this.standardDataTableRef.refresh());
    }

    private customTableColumns(): DataTableColumnProps<StudentGameCompletionReportDTO>[] {
        let columns: DataTableColumnProps<StudentGameCompletionReportDTO>[] = [
            DataTable.AdvancedColumns.Text(<Translate id='common.headers.firstName' />, "firstName"),
            DataTable.AdvancedColumns.Text(<Translate id='common.headers.lastName' />, "lastName"),
            DataTable.BetterColumns.Custom(<Translate id='common.headers.currentGrade' />, "currentGradeName", {
                width: 150,
                // Show name but sort on Ids
                sorter: (a, b) => a.currentGradeId - b.currentGradeId
            }),

            DataTable.BetterColumns.Custom(<Translate id='common.headers.activityGrade' />, "activityGradeName", {
                width: 150,
                // Show name but sort on Ids
                sorter: (a, b) => a.activityGradeId - b.activityGradeId
            }),
            DataTable.AdvancedColumns.Text(<Translate id='common.headers.planet' />, "planetName"),
            DataTable.AdvancedColumns.Text(<Translate id='common.headers.game' />, "gameName"),
            DataTable.AdvancedColumns.Date(<Translate id='common.headers.completedDate' />, "completedDate"),
        ];

        return columns;
    }

    render() {
        return (
            <div className="admin-report student-planet-completion-report">
                <h2><Translate id="admin.sideNav.gameCompletionReport" /></h2>
                <p>Games Completion Report provides quick access to review games completed by students in your school. Grade column in the result table indicates student’s current grade.</p>
                <p>Report period is setup to use school years. School years start on August 1st and end on July 31st.</p>
                <p><Icon className="info-icon" type="info-circle" /> Click these icons for additional information.</p>
                <hr />
                <ReportHeader
                    reportingEvent={"Game Completion"}
                    isLoading={this.state.isLoading}
                    defaultSchoolYears={"Previous 2"}
                    onSubmit={this.handleOnSubmit}
                    onReset={this.handleOnReset}
                />
                <DataTable
                    ref={ref => this.standardDataTableRef = ref}
                    serverSide={true}
                    tableProps={{
                        // UserId is not unique
                        // rowKey: NameOf<StudentGameCompletionReportDTO>("userId"),
                        loading: this.state.isLoading,
                        pagination: {
                            defaultPageSize: 100,
                            showTotal: DataTable.StandardTotalsRenderer,
                            showSizeChanger: true,
                            pageSizeOptions: ["10", "25", "100", "9999"],
                        }
                    }}
                    columns={this.customTableColumns()}
                    data={[]}
                    fetchData={this.fetchData}
                    buttonBar={[
                        new DataTableButtonExport("Game Completion Report")
                    ]}
                />
            </div>
        );
    }
}

export default StudentGameCompletionReport;



// WEBPACK FOOTER //
// ./src/pages/admin/reports/StudentGameCompletionReport.tsx